var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00683594H478.8V341.993H0V-0.00683594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00683594H513V341.993H0V-0.00683594Z",
    fill: "#073AB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00683594H257.64V170.993H0V-0.00683594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.88 -0.00683594H243.96V159.593H161.88V-0.00683594Z",
    fill: "#F44653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00683594H82.08V159.593H0V-0.00683594Z",
    fill: "#1035BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0791 -0.00683594H164.159V159.593H82.0791V-0.00683594ZM330.599 136.793H444.599L433.199 159.593H398.999V170.993H421.799L410.399 193.793H398.999V227.993H376.199V159.593H341.999L330.599 136.793ZM421.799 193.793L444.599 227.993H398.999L421.799 193.793ZM353.399 193.793L376.199 227.993H330.599L353.399 193.793ZM387.599 262.193L364.799 227.993H410.399L387.599 262.193ZM455.999 182.393C449.159 182.393 444.599 177.833 444.599 170.993C444.599 164.153 449.159 159.593 455.999 159.593C462.839 159.593 467.399 164.153 467.399 170.993C467.399 177.833 462.839 182.393 455.999 182.393ZM319.199 182.393C312.359 182.393 307.799 177.833 307.799 170.993C307.799 164.153 312.359 159.593 319.199 159.593C326.039 159.593 330.599 164.153 330.599 170.993C330.599 177.833 326.039 182.393 319.199 182.393ZM341.999 273.593C335.159 273.593 330.599 269.033 330.599 262.193C330.599 255.353 335.159 250.793 341.999 250.793C348.839 250.793 353.399 255.353 353.399 262.193C353.399 269.033 348.839 273.593 341.999 273.593ZM433.199 273.593C426.359 273.593 421.799 269.033 421.799 262.193C421.799 255.353 426.359 250.793 433.199 250.793C440.039 250.793 444.599 255.353 444.599 262.193C444.599 269.033 440.039 273.593 433.199 273.593ZM387.599 296.393C380.759 296.393 376.199 291.833 376.199 284.993C376.199 278.153 380.759 273.593 387.599 273.593C394.439 273.593 398.999 278.153 398.999 284.993C398.999 291.833 394.439 296.393 387.599 296.393Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTf);
export default __webpack_public_path__ + "static/media/TF.4ce79c245dcd99e0b86418a2534ad981.svg";
export { ForwardRef as ReactComponent };